import auth from "./auth/reducer";
import themeChanger from "./themeChanger/reducer";
import LanguageSwitcher from "./languageSwitcher/reducer";
import themeSetting from "./themeSettings/reducer";
import customTheme from "./customTheme/reducer";
import carousel from "./carousel/reducer";
import floatingMenu from "./floatingMenu/reducer";
import cookie from "./cookie/reducer";
import fakeServer from "./fakeserver/reducer";
import modal from "./modal/reducer";
import priceReducer from "./price/price.reducer";
import cartReducer from "./cart/reducer";
import errorReducer from "./error/reducer";

export default {
  auth,
  themeChanger,
  LanguageSwitcher,
  themeSetting,
  customTheme,
  // groceryList,
  carousel,
  cookie,
  floatingMenu,
  fakeServer,
  modal,
  priceReducer,
  cartReducer,
  errorReducer
};
